var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-icon_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 103 125"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icon_svg__linear-gradient",
    x1: 72.36,
    y1: 16.81,
    x2: -12.94,
    y2: 64.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e0004b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#df024b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#db0b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d5194c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc2b4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icon_svg__linear-gradient-2",
    x1: 4651.45,
    y1: 1409.5,
    x2: 4566.15,
    y2: 1456.78,
    gradientTransform: "rotate(180 2341.045 758.845)",
    xlinkHref: "#logo-icon_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, ".logo-icon_svg__cls-2{fill:#f05}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.19 4.65v20.51A2.11 2.11 0 0177.08 27L2.27 68.33v-24.1a2.38 2.38 0 011.26-2.07L74.74 2.8a2.29 2.29 0 013.45 1.85z",
    fill: "url(#logo-icon_svg__linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logo-icon_svg__cls-2",
    d: "M46.84 70.77L6.48 45.49s-2-1-2.05-2.29a2.78 2.78 0 011.05-2.12l-2 1.08a2.78 2.78 0 00-1.06 1.11 2 2 0 00-.2.87v27.1a2.21 2.21 0 001.06 1.86l20.26 12.67a2.47 2.47 0 002.49.06l20.7-11.43a2.08 2.08 0 00.11-3.63z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.81 120.35V99.84A2.11 2.11 0 0125.92 98l74.81-41.33v24.1a2.38 2.38 0 01-1.26 2.07L28.26 122.2a2.29 2.29 0 01-3.45-1.85z",
    fill: "url(#logo-icon_svg__linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logo-icon_svg__cls-2",
    d: "M56.16 54.23l40.36 25.28s2 1 2 2.29a2.78 2.78 0 01-1 2.12l2-1.08a2.78 2.78 0 001.06-1.11 2 2 0 00.2-.87V53.75a2.21 2.21 0 00-1.06-1.86L79.46 39.23a2.47 2.47 0 00-2.46-.06L56.27 50.6a2.21 2.21 0 00-.11 3.63z"
  })));
};
export default SvgLogoIcon;